import React, { PureComponent } from 'react';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';

import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const Banner = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
        };
        render() {
            const { content } = this.props;
            const sliderTmpl = newContent => (
                <li>
                    <img src={newContent.src} />
                </li>
            );
            const config = {
                arrows: true,
                dots: false,
                dotsAction: 'click',
                autoplay: true,
                autoplayInterval: 3000,
                speed: 300,
                dotStyle: styles.dot,
                dotCurrentStyle: styles.current,
                unitSize: 0,
                sliderTmpl,
            };

            return (
                <div className={styles.sh_banner}>
                    <div className={styles.col_w1000} />
                    <div className={styles.box}>
                        <ul className={styles.list1}>
                            <Slides config={config} content={content} />
                        </ul>
                    </div>
                </div>
            );
        }
    },
);

export { Banner };
export default Banner;
